import LayoutBasic from '../layouts/layoutBasic'
import Link from 'next/link'
import {PASSWORD_RESET, GET_USER_URL} from '../vars'
import {getLocalKeyValue} from '../storage'
import { withRouter } from 'next/router'
import {GET, UPOST} from '../helpers'
import ReCAPTCHA from "react-google-recaptcha";
class Password_reset extends React.Component {
  constructor(){
    super()
    this.state = {password:'',password1:'',email:'',submit_success:false, submit_failed:false, submitting:false,msg:''}
  }
  inputChange = (e)=> {
    let name = e.target.name
    let value = e.target.value

    this.setState({
      [name]: value
    });
    this.setState({submit_failed:false, submit_success:false, submitting:false, msg: ''})
  }

  password_reset_email = (e) => {
    this.setState({submitting:true})
    e.preventDefault();
    let data = {email:this.state.email,reCaptcha:this.state.reCaptcha_value}

    UPOST(PASSWORD_RESET, data).then((response)=>{
      if (response.data.success){
        this.setState({submit_success:true, submitting:false,msg:"We've emailed you instructions for setting your password. If they haven't arrived in a few minutes, check your spam folder"})
      }
      }).catch((res) => {
       if (res.response.data.error){
        this.setState({submit_failed:true, submitting:false,msg:res.response.data.error})
      }
      else {
        this.setState({submit_failed:true, submitting:false,msg:'Something went wrong'})
      }
    })
  }

  reCaptchaChange = (value) => {
    this.setState({reCaptcha_value:value})
  }

  render() {
    let form
    let submitButton = <button type="submit" className="btn btn-primary btn-block" disabled="disabled">Password Reset</button>

    if (this.state.email && this.state.reCaptcha_value){
      submitButton = <button type="submit" className="btn btn-primary btn-block">Password Reset</button>
    }

    if(this.state.submit_failed) {
      submitButton = <button type="submit" className="btn btn-danger btn-block" disabled>Failed</button>
    }
    if(this.state.submit_success) {
      submitButton = <button type="submit" className="btn btn-success btn-block">Success</button>
    }
    if(this.state.submitting) {
      submitButton = <button type="submit" className="btn btn-primary btn-block" disabled>Submitting ...</button>
    }

    let reCaptcha = <ReCAPTCHA
      ref="reCaptcha"
      sitekey="6LcBCLAUAAAAALrXPtrZEGCSNk7LcUS5BwhlBaOc"
      onChange={this.reCaptchaChange}
      />

    form = <div><form onSubmit={this.password_reset_email}>
      <div className="form-group">
        <label htmlFor="email" className="text-muted ">Email</label>
          <input id="email" name="email" type="email" className="form-control" onChange={this.inputChange} required/>
      </div>
      <div className="form-group">
        {reCaptcha}
      </div>
      <h6>
        <p>{this.state.msg}</p>
      </h6>
      {submitButton}
    </form>
    </div>

    if(this.state.submit_success) {
      form = <h6 className="text-center">
        <p>{this.state.msg}</p>
      </h6>
    }
    return <LayoutBasic title="Password reset" {...this.props}>
            <div className="container mb-5">
              <div className="row justify-content-center">
                <div className="col-sm-8 col-md-5">
                  <h1 className="space-mb-medium text-center">
                  <>Password Reset</>
                  </h1>

                  {form}
                </div>
              </div>
            </div>

            </LayoutBasic>
  }
}
export default withRouter(Password_reset)
